export default "__VITE_ASSET__CfUUKjfL__"